// Matches a 3-5 character alphanumeric airport code inside parentheses anywhere
// in the name, e.g. "Aurora State (UAO)" → "UAO". Shared across normalize,
// weatherMatching, and any other consumer that needs to extract a code from a
// backend-supplied restriction name.
export const AIRPORT_CODE_PATTERN = /\(([A-Z0-9]{3,5})\)/;
